import type { SupportReportKind } from "@/types/support/api-types/support-report-types";

/** Mirrors backend SupportReportKind; the labels match the copilot's approval card (copilot/capabilities/support.py). */
export const SUPPORT_REPORT_KIND_OPTIONS = [
  { value: "bug", label: "Problem" },
  { value: "question", label: "Question" },
  { value: "feature_request", label: "Idea" },
  { value: "feedback", label: "Feedback" },
] as const satisfies ReadonlyArray<{ value: SupportReportKind; label: string }>;
